import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Plus, X, Tags } from "lucide-react";

export function DocCategoriesCard({ wid, initial }) {
  const [cats, setCats] = useState([]);
  const [val, setVal] = useState("");
  const [dirty, setDirty] = useState(false);
  useEffect(() => { if (wid) { setCats(initial || []); return; } api.get("/workspace/doc-categories").then(({ data }) => setCats(data.categories)).catch(() => {}); /* eslint-disable-next-line */ }, [wid]);
  const add = () => { const v = val.trim(); if (!v || cats.some((c) => c.toLowerCase() === v.toLowerCase())) return; setCats([...cats, v]); setVal(""); setDirty(true); };
  const save = async () => {
    try { const { data } = await api.put(wid ? `/workspaces/${wid}/doc-categories` : "/workspace/doc-categories", { categories: cats }); setCats(data.categories); setDirty(false); toast.success("Doc categories saved"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <div className="rounded-3xl border border-[#EEEFEF] premium-shadow bg-white p-6" data-testid="doc-categories-card">
      <div className="flex items-center gap-2 mb-1"><Tags className="h-4 w-4 text-[#723FFF]" /><h3 className="font-display text-lg font-semibold text-[#06060C]">Doc categories</h3></div>
      <p className="text-sm text-[#9FA1A4] mb-4">Categories your agency can assign to this client's documents.</p>
      <div className="flex flex-wrap gap-2 mb-4">
        {cats.length === 0 && <span className="text-xs text-[#c4c5cc]">No categories yet.</span>}
        {cats.map((c) => (
          <span key={c} data-testid="doc-category-chip" className="inline-flex items-center gap-1.5 rounded-full bg-[#EDE7FF] text-[#5b2fd6] text-xs px-3 py-1">{c}
            <button onClick={() => { setCats(cats.filter((x) => x !== c)); setDirty(true); }} className="hover:text-rose-600"><X className="h-3 w-3" /></button></span>
        ))}
      </div>
      <div className="flex gap-2 max-w-md">
        <Input data-testid="doc-category-input" value={val} onChange={(e) => setVal(e.target.value)} onKeyDown={(e) => { if (e.key === "Enter") add(); }} placeholder="e.g. Blog, Social, Landing page" className="bg-[#F6F6FD] border-[#EEEFEF]" />
        <Button data-testid="doc-category-add" variant="outline" onClick={add} className="rounded-full border-[#EEEFEF]"><Plus className="h-4 w-4" /></Button>
        <Button data-testid="doc-category-save" disabled={!dirty} onClick={save} className="rounded-full bg-[#06060C] text-white hover:bg-[#1c1c24]">Save</Button>
      </div>
    </div>
  );
}
